import { render } from "./RiskView.vue?vue&type=template&id=6716046b&scoped=true"
import script from "./RiskView.vue?vue&type=script&lang=js"
export * from "./RiskView.vue?vue&type=script&lang=js"

import "./RiskView.vue?vue&type=style&index=0&id=6716046b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6716046b"]])

export default __exports__